var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[_c('navbar'),_c('div',{staticClass:"sidebar-main-container"},[_c('Aside'),_c('app-main')],1),_c('x-message',{ref:"xMessage"}),_c('x-notice',{ref:"xNotice"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }